import {EventBus} from "../../hermeneus.eventbus/eventbus";
import axios from "axios";
import {haxiosAPIClient} from "@/haxios/haxios.js";


/**
 * Stellt die UebungenRegistry als Global Property zur Verfügung
 */
export let providesUebungenRegistryPlugin = {
    install: function (app, options) {
        app.config.globalProperties.$UebungenRegistry = window.UebungenRegistry || false;

        app.config.globalProperties.$fetchUebungenRegistry = async () => {
            try {
                const response = await haxiosAPIClient.get('/uebungen/registry')
                app.config.globalProperties.$UebungenRegistry = response.data;
            } catch (error) {
                console.error('Fehler beim Laden der UebungenRegistry:', error);
            }

        };

        /**
         * Ermittelt eine Übung aus der UebungenRegistry anhand des Models
         * @param Model
         * @returns {unknown}
         */
        app.config.globalProperties.$resolveUebungFromRegistry = function (Model) {
            if (!this.$UebungenRegistry) {
                console.log('UebungenRegistry ist nicht gesetzt.');
            } else {

                return Object.values(this.$UebungenRegistry.registered_uebungen).filter((uebung) => {
                    return uebung.model == Model;
                })[0];
            }
        };

    },

}